import { useEffect, useState } from "react";

function formatTime(value) {
  return value.toString().padStart(2, "0");
}

export const Clock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const hours = formatTime(time.getHours());
  const minutes = formatTime(time.getMinutes());
  const seconds = formatTime(time.getSeconds());

  return (
    <div className="text-Regular(18_24) text-Content/Dark">
      {hours} : {minutes} : {seconds}
    </div>
  );
}